import { Button, cn } from '@prenuvo/halo-foundation';

import { FCT } from '@/i18n';

import { useReportIssue } from '../../use-report-issue.hook';
import { useReportIssueHandler } from '../use-report-issue-handler.hook';

function ReportFormActions() {
  const { onToggleReportIssue } = useReportIssue();
  const {
    handleSubmit,
    isReportIssueSuccess,
    isReportServiceDeskIssueSuccess,
    resetForm,
    resetReportIssue,
    resetReportServiceDeskIssue,
  } = useReportIssueHandler();

  const isSuccess = isReportIssueSuccess || isReportServiceDeskIssueSuccess;

  return (
    <div className={cn('flex justify-end gap-4', { 'justify-center': isSuccess })}>
      {isSuccess ? (
        <Button
          className={{ root: 'px-8' }}
          data-testid="close-button"
          onClick={() => {
            onToggleReportIssue(false);
            resetReportIssue();
            resetReportServiceDeskIssue();
          }}
          variant="primary"
        >
          {FCT.REPORTING.REPORT_ISSUE.ACTIONS.CLOSE}
        </Button>
      ) : (
        <div className="flex gap-4">
          <Button
            className={{ root: 'px-8' }}
            data-testid="cancel-button"
            onClick={() => {
              onToggleReportIssue(false);
              resetForm();
            }}
            variant="outlined"
          >
            {FCT.REPORTING.REPORT_ISSUE.ACTIONS.CANCEL}
          </Button>
          <Button
            className={{ root: 'px-8' }}
            data-testid="submit-button"
            onClick={handleSubmit}
            variant="primary"
          >
            {FCT.REPORTING.REPORT_ISSUE.ACTIONS.SUBMIT}
          </Button>
        </div>
      )}
    </div>
  );
}

export { ReportFormActions };
